import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import Button from "./Button";
import DropdownButton from "./DropdownButton";
import Icon from "./Icon";
import Moment from "./Moment";
import styles from "./EmailListItem.module.css";
import { history } from "../history";

export default class EmailListItem extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.onClone = this.onClone.bind(this);
    this.onDelete = this.onDelete.bind(this);
  }

  onClone() {
    const { id } = this.props.email;
    this.props.onClone(id);
  }

  async onDelete() {
    const { accountId, campaignId, email } = this.props;
    const { id } = email;
    await this.props.onDelete(id);
  }

  handleClick() {
    const { id, campaignId } = this.props.email;
    const { accountId } = this.props;
    history.push(`/clients/${accountId}/campaigns/${campaignId}/emails/${id}`);
  }

  render() {
    const { id, campaignId, name, updatedAt, updatedByName, EmailTemplate } =
      this.props.email;
    const { accountId } = this.props;

    return (
      <tr>
        <td className={styles.name} onClick={this.handleClick}>
          <Icon icon="file" />
          {` `}
          {name}
        </td>
        <td style={{ width: "200px" }} onClick={this.handleClick}>
          <div className={styles.preview}>
            {id && accountId && (
              <img
                src={`${process.env.REACT_APP_API_ENDPOINT}/api/clients/${accountId}/emails/${id}/image?updatedAt=${updatedAt || Date.now()}`}
              />
            )}
          </div>
        </td>
        <td onClick={this.handleClick}>
          {EmailTemplate && EmailTemplate.name}
        </td>
        <td style={{ width: "150px" }} onClick={this.handleClick}>
          {updatedByName}
        </td>
        <td style={{ width: "180px" }}>
          <Moment date={updatedAt} />
        </td>
        <td style={{ width: "300px", textAlign: "right" }}>
          <Link
            to={`/clients/${accountId}/campaigns/${campaignId}/emails/${id}/qa`}
          >
            <Button type="link" title="QA">
              <Icon icon="ambulance" />
            </Button>
          </Link>
          <Link
            to={`/clients/${accountId}/campaigns/${campaignId}/emails/${id}`}
          >
            <Button type="link" title="Edit">
              <Icon icon="pencil" />
            </Button>
          </Link>
          <a
            href={`${process.env.REACT_APP_API_ENDPOINT}/api/clients/${accountId}/emails/${id}/download`}
          >
            <Button type="link" title="Download">
              <Icon icon="download" />
            </Button>
          </a>
          <DropdownButton
            type="link"
            pin="right"
            options={[
              {
                label: "Clone",
                onClick: this.onClone,
              },
              {
                type: "divider",
              },
              {
                label: "Delete",
                onClick: this.onDelete,
              },
            ]}
          />
        </td>
      </tr>
    );
  }
}

EmailListItem.propTypes = {
  accountId: PropTypes.string.isRequired,
  email: PropTypes.object.isRequired,
  onClone: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};
